module.exports = __webpack_public_path__ + "media/images/front/logo_dba-c04a7b9fbaefbe9fa4658b124df66331.png";